import * as ActionTypes from './../constants';
import { baseUrl } from './../index';
// import { AsyncStorage } from 'react-native';
import axios from 'axios';
import { getUserToken } from './../getUserToken';

export default function(state={},action){
    switch(action.type){
        case ActionTypes.REQUEST_GET_VIMEO__VIDEO_URL_WITH_VIDEO_ID:
            return {
                ...state,
                loading:true,
                error:false,
                errorInfo:null,
            }
        case ActionTypes.RECEIVED_GET_VIMEO__VIDEO_URL_WITH_VIDEO_ID:
            return {
                ...state,
                loading:false,
                response:action.res,
                error:false,
                errorInfo:null
            }
        case ActionTypes.ERROR_GET_VIMEO__VIDEO_URL_WITH_VIDEO_ID:                
        return {
            ...state,
            loading:false,
            error:true,
            errorInfo:action.err
        }
        case ActionTypes.CLEAR_GET_VIMEO__VIDEO_URL_WITH_VIDEO_ID:
        return {}
        default: return state
    } 

}

const dispatchRequestGetVimeoPlayerUrlWithId= updateProfileData => ({
        type:ActionTypes.REQUEST_GET_VIMEO__VIDEO_URL_WITH_VIDEO_ID,
        updateProfileData
})

const dispatchReceivedGetVimeoPlayerUrlWithId= res =>({
    type:ActionTypes.RECEIVED_GET_VIMEO__VIDEO_URL_WITH_VIDEO_ID,
    res
})

const dispatchErrorVimeoPlayerUrlWithId = (err) => ({
    type:ActionTypes.ERROR_GET_VIMEO__VIDEO_URL_WITH_VIDEO_ID,
    err
})

const dispatchClearVimeoPlayerUrlWithId= () => ({
    type: ActionTypes.CLEAR_GET_VIMEO__VIDEO_URL_WITH_VIDEO_ID
})

export const clearVimeoPlayerWithId = () => dispatchClearVimeoPlayerUrlWithId();

export const getVimeoPlayerUrlWithId= (videoId) => dispatch => {

    dispatch(dispatchRequestGetVimeoPlayerUrlWithId(videoId));

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'get',
                url: `https://player.vimeo.com/video/${videoId}/config`,
                // headers: {
                //     'Authorization': `Bearer ${authKey}`,
                //     'Content-Type': 'application/json'
                // }
            }
            // fetch(options.url, options)
            //     .then(res => res.json())
            //     .then(data =>  dispatchReceivedUpdateProfile(data))
            //     .catch(e  => dispatchErrorUpdateProfile(e));

            return axios(options)
                .then(res => {
                    dispatch(dispatchReceivedGetVimeoPlayerUrlWithId(res.data))
                  console.log(res, "data")
                })
                .catch(e => dispatch(dispatchErrorVimeoPlayerUrlWithId(e)))

        })
        .catch(e => dispatch(dispatchErrorVimeoPlayerUrlWithId(e.response)));
}